module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/AO-8e99ff46bf63ce4610c9ff364caf8c51.png";